/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();

import { useAtomValue } from 'jotai'
import { useEffect, useRef } from 'react'

import { basketGa4Items } from '@/lib/analytics/ga4-items'
import { trackEvent } from '@/lib/analytics/google'
import { currencyAtom, pricedBasketItemsAtom, subtotalAtom } from '@/store/basket'

/**
 * Automatically tracks the view_cart event once when the basket is viewed.
 * Uses a ref to prevent duplicate tracking on subsequent renders.
 */
const useTrackViewCart = () => {
  const pricedItems = useAtomValue(pricedBasketItemsAtom)
  const subtotal = useAtomValue(subtotalAtom)
  const currency = useAtomValue(currencyAtom)
  const hasTracked = useRef(false)

  useEffect(() => {
    if (pricedItems.length > 0 && subtotal && currency && !hasTracked.current) {
      trackEvent('view_cart', {
        currency: currency,
        value: subtotal.amount,
        items: basketGa4Items(pricedItems),
      })

      hasTracked.current = true
    }
  }, [pricedItems, subtotal, currency])
}

export { useTrackViewCart }
